__turbopack_context__.v({
  "arriving": "client-log-visual-module__bbh5XG__arriving",
  "arrivingIn": "client-log-visual-module__bbh5XG__arrivingIn",
  "fileRow": "client-log-visual-module__bbh5XG__fileRow",
  "hideNarrow": "client-log-visual-module__bbh5XG__hideNarrow",
  "logRow": "client-log-visual-module__bbh5XG__logRow",
  "marked": "client-log-visual-module__bbh5XG__marked",
  "reveal": "client-log-visual-module__bbh5XG__reveal",
  "revealVisible": "client-log-visual-module__bbh5XG__revealVisible",
  "root": "client-log-visual-module__bbh5XG__root",
});
